export default __webpack_public_path__ + "static/media/home_banner_2.eb66f991.png";